/**
 *
 * Asynchronously loads the component for SettingsModule
 *
 */

import { lazyLoad } from 'utils/loadable';

export const SettingsModule = lazyLoad(
  () => import('./index'),
  module => module.SettingsModule,
);
